import { useEffect } from 'react'
import RankingItem from './RankingItem'

const RankingListItems = ({ ranking }: { ranking?: any }) => {

  useEffect(() => {
    console.log(ranking)
  }, [ranking])

  if (ranking?.rankWinners?.length === 0) {
    return (
      <div className='ranking__list-items__empty'>
        <p>
          Aún no hay participantes, verás las posiciones aquí cuando se active.
        </p>
      </div>
    )
  }

  return (
    <div className='ranking__list-items'>
      {ranking?.rankWinners?.map((user: any) => (
        <RankingItem key={user.id} user={user} />
      ))}
    </div>
  )
}

export default RankingListItems